import { APAlternatePlanListQuery } from '../../../alternate_plans/queries/ap_alternate_plan_list_query';

class AlternatePlanList {
  constructor(private ngAPAlternatePlanListQuery: APAlternatePlanListQuery) {}
}
angular.module('capability-ng-academic-planner').component('alternatePlanList', {
  templateUrl:
    'capability-ng-academic-planner/src/alternate_plans/components/alternate_plan_list/alternate_plan_list.html',
  controller: AlternatePlanList
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/alternate_plans/components/alternate_plan_list/alternate_plan_list.ts